<template>
  <div class="bb-kpi-reports" :class="{'bb-kpi-reports_no-entries': !reportsList || reportsList.length === 0}">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-kpi-reports-header">
      <div class="bb-kpi-reports-header__department">{{currentDepartment.name || ''}}</div>
      <FilterByDate :get-query="getReports" position="right"/>
    </div>
    <div v-if="reportsList && reportsList.length > 0" class="bb-kpi-reports-container">
      <div class="bb-kpi-reports-body-report bb-kpi-reports-body-report_header">
        <div class="bb-kpi-reports-body-report__name">Filename</div>
      </div>
      <vue-perfect-scrollbar class="bb-kpi-reports-body">
        <a class="bb-kpi-reports-body-report"
           :class="{'bb-kpi-reports-body-report_first': index === 0}"
           :download="report.label"
           :href="report.path"
           v-for="(report, index) in reportsList"
           :key="report.id">
          <div class="bb-kpi-reports-body-report__name">{{report.label}}</div>
        </a>
      </vue-perfect-scrollbar>
      <Pagination :data="reportsData" :getQuery="getReports" :limit="defLimit" class="bb-pagination"/>
    </div>
    <template v-else>
      <div class="bb-kpi-reports-body-report__no-entries">
        <TableNoData explanation="Sorry, no reports found."/>
      </div>
    </template>
  </div>
</template>

<script>
import {find} from 'lodash'
import moment from 'moment'
import KpiApi from '@/api/Kpi/api'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import Pagination from '@/components/Main/Pagination/Pagination'
import FilterByDate from '@/components/Main/FilterByDate/FilterByDate'
import departmentsTypes from '@/constants/departmentsTypes'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import TableNoData from '@/components/Main/Table/TableNoData/TableNoData'

export default {
  name: 'KpiReports',
  props: ['department'],
  components: {
    TableNoData,
    FilterByDate,
    LoaderFly,
    Pagination,
    VuePerfectScrollbar
  },
  data () {
    return {
      reportsData: [],
      fullData: {},
      defLimit: 25,
      loaderRun: false
    }
  },
  computed: {
    reportsList () {
      const list = this.reportsData.kpireportexcels || []
      return this.formatDate(list, 'formatDate', 'date')
    },
    currentDepartment () {
      const department = find(departmentsTypes, {id: this.department}) || {}
      department.name = department.name.replace(/Dept/gmi, 'Department')
      return department
    }
  },
  methods: {
    formatDate (list, newProps, oldProps) {
      return list.map(item => {
        if (item[oldProps]) {
          const date = new Date(item[oldProps])
          item[newProps] = moment(date).format('DD-MMM-YY')
        }
        return item
      })
    },
    getReports ({limit = this.defLimit, page, filter}) {
      const query = {
        limit: limit,
        page: page,
        department: this.department,
        date: filter
      }
      this.loaderRun = true
      KpiApi.getReports(query)
        .then((resp) => {
          this.loaderRun = false
          this.reportsData = resp.data
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    }
  },
  beforeMount () {
    this.getReports({})
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-kpi-reports {
    @include global-font;
    min-width: 420px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 280px;

    &_no-entries {
      justify-content: flex-start;
    }

    &-header {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &__department {
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
      }
    }

    &-container {
      min-height: 204px;
    }

    &-body {
      padding-right: 31px;
      margin: 0 -31px 20px 0;
      overflow: hidden;
      max-height: 40vh;

      &-report {
        position: relative;
        display: flex;
        align-items: center;
        min-height: 51px;
        font-size: 14px;
        padding: 10px 0;
        color: inherit;
        text-decoration: none;
        cursor: pointer;
        transition: .3s;

        &:hover {
          opacity: 0.6;
        }

        &:after {
          content: '';
          position: absolute;
          top: 0;
          width: 100%;
          height: 1px;
          background-color: $color-wild-sand;
        }

        &_first {
          &:after {
            display: none;
          }
        }

        &_header {
          margin-top: 20px;
          color: $color-accent;
          font-weight: bold;
          line-height: 14px;
          pointer-events: none;

          &:after {
            top: auto;
            bottom: 0;
          }
        }

        &__date {
          width: 100px;
        }

        &__no-entries {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          justify-self: center;
          margin: auto;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Finance/KPI/KpiReports/KpiReports.vue